<mat-dialog-content class="h-full">
  <div class="evaluation-wrapper flex flex-col h-full">
    <div class="evaluation-wrapper__header flex items-center gap-2 mb-4">
      <mat-icon class="evaluation-wrapper__icon">rate_review</mat-icon>
      <h2 class="evaluation-wrapper__title">Avaliação de Atendimento</h2>
    </div>

    <p class="evaluation-wrapper__name mb-4" *ngIf="data.questionnaireName">
      <strong>{{ data.questionnaireName }}</strong>
    </p>

    <div class="evaluation-wrapper__body flex-1">
      <div *ngFor="let item of data.questions" class="evaluation-item mb-3">
        <p class="evaluation-item__question font-semibold">{{ item.question }}</p>
        <p class="evaluation-item__answer">{{ item.answer || '-' }}</p>
      </div>

      <p *ngIf="!data.questions || data.questions.length === 0" class="evaluation-wrapper__empty">
        Nenhuma resposta registrada.
      </p>
    </div>

    <div class="evaluation-wrapper__botoes flex justify-end mt-4">
      <button class="px-5 btn btn--primary h-35" mat-button [mat-dialog-close]="true">
        Fechar
      </button>
    </div>
  </div>
</mat-dialog-content>
